interface Address {
  altitude: number
  cityCode: string
  cityName: string
  countryCode: string
  countryName: string
  latitude: number
  longitude: number
  streetName: string
}

interface AgeRange {
  Maximum: number
  Minimum: number
}

interface AlternativeDay {
  AccommodationDates: RangeDateTime
  Discount: Discount | null
  MinimalPrice: Price
}

interface ContactData {
  ContactPerson: string
  Email: string | null
  Phone: Phone | null
  WebSite: string | null
}

interface Discount {
  Code: string
  currencyIsoCode: string
  DiscountType: ModifierType
  Amount: number
  AmountType: AmountType
  IsAlreadyApplied: boolean
  DiscountTypeText: string
  AmountTypeText: string

  AmountAfterTax: number
  Description: string
  AmountBeforeTax: number
  ModifierName: string
}

interface Hotel {
  address: Address
  code: string
  name: string
  category: string

  currencyIsoCode: string
  timeZone: string
  contactData: ContactData
  hotelStaticData: HotelStaticData[] | null
  reputation: Reputation | null
  PaxConfiguration: PaxConfiguration
}

interface HotelStaticData {
  languageIsoCode: string
  largeDescription: string
  shortDescription: string
  locationCode: string
  images: Image[] | null
  meals: MealStaticData[]
  RateStaticData: RateStaticData[]
  rooms: RoomStaticData[]
  ServiceCategories: ServiceCategory[]
  Tax: Tax
  services: Service[]
}

interface Image {
  isMainImage: boolean
  order: number
  url: string
}

interface MealStaticData {
  code: string
  description: string
  name: string
}

interface PaxConfiguration {
  Baby: AgeRange
  Child: AgeRange
  Teenager: AgeRange
}

interface Phone {
  Number: string
  Prefix: string
}

interface Price {
  currencyIsoCode: string
  amount: number
}

interface RateStaticData {
  Code: string
  Description: string
  Name: string
}

interface RangeDateTime {
  Format: string
  From: string
  To: string
}

interface Reputation {
  Description: string
  Value: number
}

interface RoomBed {
  Description: string
  Size: number
  width: number
  height: number
  Type: RoomBedType
}

interface RoomStaticData {
  code: string
  description: string
  images: Image[]
  isRoomAdapted: boolean
  name: string
  numberOfUnits: number
  roomBeds: RoomBed[]
  serviceCategories: ServiceCategory[]
  shortDescription: string
  largeDescription: string
  type: string
}

interface Service {
  Code: string
  Description: string
  Icon: string
  Name: string
}

interface ServiceCategory {
  Code: string
  Description: string
  Icon: string
  Name: string
  Services: Service[]
}

interface Tax {
  Amount: number
  Description: string
  TaxType: TaxType
}

export enum AmountType {
  Fixed,
  Percent
}

export enum ModifierType {
  Discount,
  Supplement,
  Unknow
}

export enum TaxType {
  Tax,
  Vat
}

export enum RoomBedType {
  Double,
  Single
}

export type {
  Address,
  AgeRange,
  AlternativeDay,
  ContactData,
  Discount,
  Hotel,
  HotelStaticData,
  Image,
  MealStaticData,
  PaxConfiguration,
  Phone,
  Price,
  RateStaticData,
  RangeDateTime,
  Reputation,
  RoomBed,
  RoomStaticData,
  Service,
  ServiceCategory,
  Tax
}
